module.exports = __webpack_public_path__ + "img/bannerhomepage.a89ead55.svg";